/** Canonical privacy policy for www.keliriji.com/privacy — keep in sync with PsycheFlow-Mobile2/assets/privacy-policy.html. No app-autostart clauses. */
export const PRIVACY_POLICY_LAST_UPDATED = '2026年7月29日';

export function PrivacyPolicyDocument() {
  return (
    <article className="text-[15px] leading-7 text-[#2D3139]">
      <header className="mb-6">
        <h1 className="mb-1 text-2xl font-extrabold tracking-tight text-ink">隐私政策</h1>
        <p className="text-sm text-muted">颗粒日记 · 最后更新：{PRIVACY_POLICY_LAST_UPDATED}</p>
        <p className="mt-1 text-sm text-muted">开发者名称：北京颗粒日记科技有限公司</p>
      </header>

      <div className="mb-6 rounded-md border-l-[3px] border-primary bg-[#EAF2FF] px-3.5 py-3 text-sm text-[#2D3139]">
        颗粒日记（以下简称「我们」或「本应用」，由北京颗粒日记科技有限公司开发运营）非常重视您的个人隐私与数据安全。请您在注册或使用本应用前，认真阅读本隐私政策，了解我们如何收集、使用及保护您的信息。
      </div>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">一、我们收集的信息</h2>
        <p className="mb-3">为向您提供服务，我们可能收集以下类型的信息：</p>
        <ul className="mb-3 list-disc space-y-1.5 pl-5">
          <li><strong className="font-semibold text-ink">账户信息：</strong>手机号码（仅用于注册和身份验证）</li>
          <li><strong className="font-semibold text-ink">用户内容：</strong>您主动上传或创建的学习素材、笔记、知识颗粒及相关标注</li>
          <li><strong className="font-semibold text-ink">使用数据：</strong>功能使用频次、学习记录等经匿名处理的统计信息</li>
          <li><strong className="font-semibold text-ink">设备信息：</strong>设备类型、操作系统版本等基础技术参数</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">二、信息的使用方式</h2>
        <p className="mb-3">我们使用收集的信息用于：</p>
        <ul className="mb-3 list-disc space-y-1.5 pl-5">
          <li>提供、维护和持续改进应用功能与用户体验</li>
          <li>发送短信验证码，完成账户注册、登录和密码重置</li>
          <li>提供个性化的学习内容推荐与复习计划调度</li>
          <li>保障账户安全与应用稳定运行</li>
          <li>响应您的客服咨询与反馈</li>
          <li>在您明示同意开启复习提醒后，于应用使用期间向您发送复习进度推送通知</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">三、信息的存储与保护</h2>
        <p className="mb-3">
          您的个人信息存储于中华人民共和国境内的服务器，受到多层安全措施保护，包括：
        </p>
        <ul className="mb-3 list-disc space-y-1.5 pl-5">
          <li>全程 HTTPS 加密传输</li>
          <li>严格的服务端访问控制</li>
          <li>敏感数据（如令牌）在本地设备上加密存储</li>
        </ul>
        <p>我们不会出售、出租或以任何方式将您的个人信息提供给第三方，法律法规另有要求的除外。</p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">四、您上传的私人内容</h2>
        <p>
          您在颗粒日记中上传或创建的学习素材、笔记等内容属于
          <strong className="font-semibold text-ink">您的私人资产</strong>
          ，由本应用独立管理。我们仅在提供相关功能所必要的最小范围内访问这些内容，不会将其用于任何其他商业目的，亦不会公开给其他用户。
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">五、Cookie 与本地存储</h2>
        <p>
          应用在您的设备本地存储加密的登录令牌，用于保持登录状态。您可以随时通过「退出登录」功能清除这些数据。
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">六、未成年人保护</h2>
        <p>
          本应用不向 14 周岁以下的未成年人提供服务。若您未满 18 周岁，请在监护人的陪同下阅读并确认本政策。
        </p>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">七、您的权利</h2>
        <p className="mb-3">根据《个人信息保护法》，您对自己的个人信息享有以下权利：</p>
        <ul className="mb-3 list-disc space-y-1.5 pl-5">
          <li><strong className="font-semibold text-ink">访问权：</strong>查询我们持有的您的个人信息</li>
          <li><strong className="font-semibold text-ink">更正权：</strong>要求更新或更正不准确的信息</li>
          <li><strong className="font-semibold text-ink">删除权：</strong>注销账户时，我们将依法删除您的个人信息</li>
          <li><strong className="font-semibold text-ink">可携权：</strong>在技术可行的前提下，获取您数据的可读副本</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">八、联系我们</h2>
        <p className="mb-3">
          如您对本隐私政策有任何疑问、意见或权利主张，可通过以下方式联系我们，我们将尽快与您联系，并在收到请求后
          <strong className="font-semibold text-ink"> 15 个工作日 </strong>
          内予以书面回复：
        </p>
        <ul className="mb-3 list-disc space-y-1.5 pl-5">
          <li>应用内「关于」页面的联系方式</li>
          <li>
            微信号：
            <strong className="font-semibold text-ink">revisionbrook</strong>
            {' '}或{' '}
            <strong className="font-semibold text-ink">GemDiaryFamily</strong>
          </li>
          <li>
            电子邮箱：
            <strong className="font-semibold text-ink">keliriji@163.com</strong>
          </li>
        </ul>
      </section>

      <section className="mb-8">
        <h2 className="mb-2.5 text-base font-bold text-[#0B5CAB]">九、政策变更</h2>
        <p>
          我们可能不定期修订本隐私政策。政策发生重大变更时，我们将在应用内显著位置进行提示，并通过短信向已注册用户发送通知。继续使用本应用即视为您接受更新后的政策。
        </p>
      </section>

      <hr className="my-8 border-border" />
      <p className="text-center text-sm text-[#8A9CB8]">© 2026 北京颗粒日记科技有限公司 · 版权所有</p>
    </article>
  );
}
